import { useEffect, useState } from "react";
import { dataSyncEmitter } from "@/modules/events/emitter";
import { Text, Flex, Button, Heading, Spinner } from "@/ui";
import { absoluteCenter } from "@/theme/utils/style";
import Icon from "@/components/Icon";
import { t } from "@/utils";
import CameraOffIcon from "assets/icons/camera_off.svg?react";
import { useCameraMethods } from "camera/modules/station";

export default function CameraOff() {
  const { changeCameraStationRecordingMode } = useCameraMethods();
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const onStart = async () => {
    if (loading || disabled) return;
    dataSyncEmitter.emit("pause-camera-start");
    setLoading(true);
    await changeCameraStationRecordingMode("ON");
    setLoading(false);
    dataSyncEmitter.emit("pause-camera-end");
  };

  useEffect(() => {
    const unsub = [
      dataSyncEmitter.on("pause-camera-start", () => setDisabled(true)),
      dataSyncEmitter.on("pause-camera-end", () => setDisabled(false))
    ];
    return () => unsub.forEach((cb) => cb());
  });

  return (
    <>
      <Flex
        {...absoluteCenter}
        top={["calc(50% + 16px)", "50%"]}
        justify="center"
        align="center"
        flexDir="column"
        textAlign="center"
        w="20rem"
        color="neutral.99"
      >
        <Icon icon={CameraOffIcon} fill="primary.80" />
        <Heading as="h5" mt={["0rem", "1rem"]} mb="0.5rem">
          {t("cameraIsPaused")}
        </Heading>
        <Text variant="body" color="neutral.90">
          {t("cameraIsPaused.subtitle")}
        </Text>
        {loading ? (
          <Spinner mt="2rem" width="40px" height="40px" />
        ) : (
          <Button
            isDisabled={disabled}
            mt="2rem"
            variant="filled"
            onClick={onStart}
            py="12"
            px="24"
            fontWeight={500}
            bg="primary.80"
            color="primary.20"
          >
            {t("startCamera")}
          </Button>
        )}
      </Flex>
    </>
  );
}
